window.BrandTreeUtils = {
    buildBrandNavigatorTree: (selectedBrands) => {
        let tree = {};
        const mappings = {};

        for (let i in selectedBrands) {
            for (let j in selectedBrands[i].parents_ids) {
                const parentId = selectedBrands[i].parents_ids[j];
                const grandParentId = selectedBrands[i].parents_ids[parseInt(j) + 1];
                const parentBrand = mappings[parentId] || {id: parentId, name: selectedBrands[i].name, brands: []};
                const grandParentBrand = grandParentId ? (mappings[grandParentId] || {
                    id: grandParentId,
                    brands: []
                }) : null;

                if (grandParentBrand) {
                    let parentExists = grandParentBrand.brands.find((item) => {
                        return item.id === parentId;
                    });

                    if (!parentExists) {
                        grandParentBrand.brands.push(parentBrand);
                    }

                    mappings[grandParentId] = grandParentBrand;
                } else {
                    tree = parentBrand;
                }

                mappings[parentId] = parentBrand;
            }
        }

        return tree;
    }
};